module.exports = __webpack_public_path__ + "static/cashew_nuts_dieu_3-26ad40735a5ab033de9920987a6ad689.jpg";